// @flow

import { authenticatedFetch } from '../../../api/request';

export default function getHeadCoachInfo() {
    return authenticatedFetch(`/v5/headCoach`);
}



// WEBPACK FOOTER //
// ./src/view/my-store/api/getheadCoachInfo.js